/* eslint-disable react/prop-types */
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import cx from 'classnames';

const style = (theme) => ({
  default: {
    padding: '0 2%',
  },
  firstItem: {
    paddingLeft: '2%',
    paddingRight: 0,
  },
  noPadding: {
    padding: 0,
  },
  fullWidth: {
    width: '100%',
    padding: '0',
  },
  justifyCenter: {
    display: 'flex',
    justifyContent: 'center',
  },
  justifyEnd: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  cardAvator: {
    padding: theme.spacing(1),
  },
  marginBottom: {
    marginBottom: '40px',
  },
  marginTop20: {
    marginTop: '20px',
  },
});

function ItemGrid({ ...props }) {
  const {
    className,
    classes,
    cardAvator,
    children,
    firstItem,
    fullWidth,
    justifyCenter,
    justifyEnd,
    noPadding,
    marginBottom,
    marginTop20,
    ...rest
  } = props;

  const itemGridClasses = cx(className, {
    [classes.default]: !firstItem || !noPadding,
    [classes.firstItem]: firstItem,
    [classes.fullWidth]: fullWidth,
    [classes.noPadding]: noPadding,
    [classes.justifyCenter]: justifyCenter,
    [classes.cardAvator]: cardAvator,
    [classes.marginBottom]: marginBottom,
    [classes.justifyEnd]: justifyEnd,
    [classes.marginTop20]: marginTop20,
  });

  return (
    <Grid item {...rest} className={itemGridClasses}>
      {children}
    </Grid>
  );
}

export default withStyles(style)(ItemGrid);
